import { render, staticRenderFns } from "./VideoInfo.vue?vue&type=template&id=1c7b210a&"
import script from "./VideoInfo.vue?vue&type=script&lang=js&"
export * from "./VideoInfo.vue?vue&type=script&lang=js&"
import style0 from "./VideoInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports